import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "dividing"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';

var DialogFooter = function DialogFooter(_ref) {
  var children = _ref.children,
      _ref$dividing = _ref.dividing,
      dividing = _ref$dividing === void 0 ? false : _ref$dividing,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var rootStyles = /*#__PURE__*/css({
    padding: '0.5rem 1rem',
    borderTop: dividing ? '1px solid #E4E7EB' : undefined
  }, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0RpYWxvZ0Zvb3Rlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBV3FCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0RpYWxvZ0Zvb3Rlci50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cblxuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHR5cGUgeyBEaWFsb2dGb290ZXJQcm9wcyB9IGZyb20gJy4uL3R5cGVzJztcblxuY29uc3QgRGlhbG9nRm9vdGVyOiBSZWFjdC5GQzxEaWFsb2dGb290ZXJQcm9wcz4gPSAoe1xuICBjaGlsZHJlbixcbiAgZGl2aWRpbmcgPSBmYWxzZSxcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IHtcbiAgY29uc3Qgcm9vdFN0eWxlcyA9IGNzcyh7XG4gICAgcGFkZGluZzogJzAuNXJlbSAxcmVtJyxcbiAgICBib3JkZXJUb3A6IGRpdmlkaW5nID8gJzFweCBzb2xpZCAjRTRFN0VCJyA6IHVuZGVmaW5lZCxcbiAgfSk7XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2IHsuLi51bmhhbmRsZWRQcm9wc30gY3NzPXtyb290U3R5bGVzfT5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5cbkRpYWxvZ0Zvb3Rlci5kaXNwbGF5TmFtZSA9ICdEaWFsb2dGb290ZXInO1xuXG5leHBvcnQgZGVmYXVsdCBEaWFsb2dGb290ZXI7XG4iXX0= */");
  return jsx("div", _extends({}, unhandledProps, {
    css: rootStyles
  }), children);
};

DialogFooter.displayName = 'DialogFooter';
export default DialogFooter;